var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-toggle",class:_vm.classes,on:{"click":_vm._click,"mousedown":_vm._mousedown,"mouseup":_vm._mouseup}},[_c('div',{staticClass:"link-toggle-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }